// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: { 
  production: boolean, 
  APIEndpoint: string, 
  ApplicationUrl: string,
  MsalConfig: any
  

} = prodSettings();

function localSettings(): { production: boolean, APIEndpoint: string, ApplicationUrl: string ,MsalConfig: any } 
{
  return {
    production: false,
    APIEndpoint: 'http://localhost:10326/',
    ApplicationUrl: 'http://localhost:58337',
    MsalConfig: {
      Api_url: 'http://localhost:10326/',
      API_Access: 'api://e0d44140-a051-416c-b070-5cc0c5c192d9/access_as_user',
      FrontEndClientId: 'e0d44140-a051-416c-b070-5cc0c5c192d9',
      GraphUri: 'https://graph.microsoft.com/',
      Authority: 'https://login.microsoftonline.com/EYGS.onmicrosoft.com/',
      RedirectUri: 'http://localhost:4200/'
    },
  
  };
}

/*function localSettings(): { production: boolean, APIEndpoint: string, ApplicationUrl: string ,MsalConfig: any } 
{
  return {
    production: false,
    APIEndpoint: 'http://localhost:10326/',
    ApplicationUrl: 'http://localhost:4200',
    MsalConfig: {
      Api_url: 'http://localhost:10326/',
      API_Access: 'api://83faf797-98cc-44e8-83ee-a19f6090d91a/user_impersonation',
      FrontEndClientId: '83faf797-98cc-44e8-83ee-a19f6090d91a',
      GraphUri: 'https://graph.microsoft.com/',
      Authority: 'https://login.microsoftonline.com/EYGS.onmicrosoft.com/',
      RedirectUri: 'http://localhost:4200/'
    },
  
  };
}*/

function uatSettings() {
   return {
    production: false,
    APIEndpoint: '/',
  ApplicationUrl: 'https://documentcentre-uat.ey.com',
  MsalConfig: {
  Api_url: 'https://documentcentre-uat.ey.com',
  API_Access: 'api://e0d44140-a051-416c-b070-5cc0c5c192d9/access_as_user',
  FrontEndClientId: 'e0d44140-a051-416c-b070-5cc0c5c192d9',
  GraphUri: 'https://graph.microsoft.com/',
  Authority: 'https://login.microsoftonline.com/EYGS.onmicrosoft.com/',
  RedirectUri: 'https://documentcentre-uat.ey.com'
},
};
}
function prodSettings() {
  return {
   production: true,
   APIEndpoint: '/',
 ApplicationUrl: 'https://documentcentre.ey.com/',
 MsalConfig: {
 Api_url: 'https://documentcentre.ey.com/',
 API_Access: 'api://13cca568-fb80-4ab7-b1f1-074d711249c2/access_as_user',
 FrontEndClientId: '13cca568-fb80-4ab7-b1f1-074d711249c2',
 GraphUri: 'https://graph.microsoft.com/',
 Authority: 'https://login.microsoftonline.com/EYGS.onmicrosoft.com/',
 RedirectUri: 'https://documentcentre.ey.com'
},
};
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
